"use client";

import { useTranslations } from "next-intl";

type RphExperienceNoticeProps = {
  className?: string;
};

export function RphExperienceNotice({ className }: RphExperienceNoticeProps) {
  const t = useTranslations("jobDetails");

  return (
    <div
      data-testid="rph-experience-notice"
      role="status"
      className={`rounded-xl border border-[#FEDF89] bg-[#FFFAEB] p-3 shadow-sm ${className ?? ""}`.trim()}
    >
      <div className="flex items-start gap-2.5">
        <div className="mt-0.5 shrink-0 text-[#B54708]">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M8 5.33331V7.99998M8 10.6666H8.00667M14.6667 7.99998C14.6667 11.6819 11.6819 14.6666 8 14.6666C4.3181 14.6666 1.33334 11.6819 1.33334 7.99998C1.33334 4.31808 4.3181 1.33331 8 1.33331C11.6819 1.33331 14.6667 4.31808 14.6667 7.99998Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <p className="text-xs leading-5 font-medium text-[#B54708]">
          {t("rphExperienceRequirement")}
        </p>
      </div>
    </div>
  );
}
